import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { Form, Table } from "react-bootstrap";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Swal from "sweetalert2";
import SplitPane from "react-split-pane";
import Pagination from "../../../Pagination";
import UseToggle from "../../../../Hooks/UseToggle";
import UpdateStudyKitMetadata from "./UpdateStudyKitMetadata";
import AddNewStudyKitMetadata from "./AddNewStudyKitMetadata";
import DeletedStudyKitMetadata from "./DeletedStudyKitMetadata";
import StudyKitMetadataActivities from "./StudyKitMetadataActivities";
import { eiwrsKitMetadataServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitMetadataServices";

const StudyKitMetadataDataList = ({ onMouseDown, tableRef }) => {
  let { studyId } = useParams();
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2 } = UseToggle();
  const [searchData, setSearchData] = useState("");
  const [kitMetaData, setKitMetaData] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [kitMetaList, setKitMetaList] = useState([]);
  const [kitMetaCount, setKitMetaCount] = useState(0);
  const [deletedStudySiteKitMeta, setDeletedStudyKitMeta] = useState([]);
  const [deletedStudySiteKitMetaCount, setDeletedStudyKitMetaCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("activities");
  const [kitMetaId, setKitMetaId] = useState("");
  const [activityLoader, setActivityLoader] = useState(false);
  const [kitMetaActivity, setKitMetaActivity] = useState([]);
  const [kitMetaActivityCount, setKitMetaActivityCount] = useState(0);
  const [tableColumns, setTableColumns] = useState({});
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(kitMetaCount / itemsPerPage);

  const getEIWRSKitMetadataData = async (e) => {
    setLoading(true);
    let data = await eiwrsKitMetadataServices.getEIWRSKitMetadataData(
      "active",
      studyId,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setKitMetaList(data?.data || []);
    setKitMetaCount(data?.count || 0);
    setLoading(false);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedEIWRSKitMetadataData = async (
    pageNumberDeleted,
    itemsPerPageDeleted
  ) => {
    let data = await eiwrsKitMetadataServices.getEIWRSKitMetadataData(
      "deleted",
      studyId,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedStudyKitMeta(data?.data || []);
    setDeletedStudyKitMetaCount(data?.count || 0);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "EIWRSKitMetadata",
      studyId,
      kitMetaData?.columnId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setKitMetaActivity(data?.data || []);
    setKitMetaActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  useEffect(() => {
    setActiveTab("activities");
  }, [kitMetaData]);

  useEffect(() => {
    getEIWRSKitMetadataData();
  }, [searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreEIWRSKitMetadata = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} Site Kit Metadata!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.id = id;
        userData.type = type;
        let data =
          await eiwrsKitMetadataServices.softDeleteRestoreEIWRSKitMetadata(
            userData
          );
        if (data?.statusCode === 200) {
          getEIWRSKitMetadataData();
          setKitMetaId("");
          getDeletedEIWRSKitMetadataData();
          if (type === "restore") {
            getDeletedEIWRSKitMetadataData(pageNumberDeleted, itemsPerPageDeleted);
            setToggle1();
          }
        }
      }
    });
  };

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          <i
            title={isFormOpen ? "Close Form" : "Add New"}
            onClick={() => {
              setIsFormOpen(!isFormOpen);
              setKitMetaId("");
            }}
            className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"
              }`}
          />
          <div className="vr"></div>
          {kitMetaCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 250, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          )}
        </div>
        <div className="hstack gap-2">
          {StudyMode === "DBP Mode" &&
            deletedStudySiteKitMetaCount > 0 &&
            <button
              onClick={() => {
                setToggle1();
                getDeletedEIWRSKitMetadataData(
                  pageNumberDeleted,
                  itemsPerPageDeleted
                );
              }}
              className={`updateProfile`}
            >
              Deleted History
            </button>
          }
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={kitMetaId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && (
            <AddNewStudyKitMetadata getEIWRSKitMetadataData={getEIWRSKitMetadataData} />
          )}
          {loading ? (
            <PageLoader />
          ) : kitMetaCount === 0 ? (
            <NoDataFoundTable MSG={"Study Kit Metadata not found!"} />
          ) : kitMetaList?.length === 0 ? (
            <NoDataFoundTable MSG={"Search Study Kit Metadata not found!"} />
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>
                      Column Label
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>
                      Column Name
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>
                      Column Type
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 4)}>
                      Is Unique
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 5)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Edit
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 6)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Delete
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {kitMetaList?.map((kitMetaData, index) => (
                    <tr
                      key={index}
                      title="View Details"
                      className={`${kitMetaId === kitMetaData?._id ? "highlighted" : ""
                        }`}
                      onClick={() => setIsFormOpen(false)}
                    >
                      <td
                        onClick={() => {
                          setKitMetaData(kitMetaData);
                          setKitMetaId(kitMetaData?._id);
                        }}
                        className="text-center"
                      >
                        {index + 1 + startIndex}.
                      </td>
                      <td
                        onClick={() => {
                          setKitMetaData(kitMetaData);
                          setKitMetaId(kitMetaData?._id);
                        }}
                      >
                        {kitMetaData?.columnLabel}
                      </td>
                      <td
                        onClick={() => {
                          setKitMetaData(kitMetaData);
                          setKitMetaId(kitMetaData?._id);
                        }}
                      >
                        {kitMetaData?.columnName}
                      </td>
                      <td
                        className="text-capitalize"
                        onClick={() => {
                          setKitMetaData(kitMetaData);
                          setKitMetaId(kitMetaData?._id);
                        }}
                      >
                        {kitMetaData?.columnType}
                      </td>
                      <td
                        className="text-capitalize"
                        onClick={() => {
                          setKitMetaData(kitMetaData);
                          setKitMetaId(kitMetaData?._id);
                        }}
                      >
                        {kitMetaData?.isUnique}
                      </td>
                      <td
                        className="text-center CP"
                        title={`Update ${kitMetaData?.kitMeta}`}
                        onClick={(e) => {
                          setKitMetaData(kitMetaData);
                          setToggle();
                          e.stopPropagation();
                        }}
                        style={{ pointerEvents: "auto" }}
                      >
                        <FaEdit className="text-muted" />
                      </td>
                      <td
                        className="text-center CP"
                        title={`Delete ${kitMetaData?.kitMeta}`}
                        onClick={(e) => {
                          softDeleteRestoreEIWRSKitMetadata(
                            kitMetaData?._id,
                            "delete"
                          );
                        }}
                      >
                        <FaTrash className={"text-danger"} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={kitMetaCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </SplitPane>
        {kitMetaId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["activities"].map(
                  (tab) => (
                    <button
                      key={tab}
                      className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""
                        }`}
                      onClick={() => setActiveTab(tab)}
                      title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  )
                )}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setKitMetaId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "activities" && (
              <StudyKitMetadataActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                kitMetaActivity={kitMetaActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                kitMetaData={kitMetaData}
                kitMetaActivityCount={kitMetaActivityCount}
                isFullScreen={isFullScreen}
              />
            )}
          </div>
        )}
      </SplitPane>
      <UpdateStudyKitMetadata
        Show={!toggle}
        Hide={setToggle}
        kitMetaData={kitMetaData}
        setKitMetaId={setKitMetaId}
        getEIWRSKitMetadataData={getEIWRSKitMetadataData}
        Title={"Update Metadata"}
      />
      <DeletedStudyKitMetadata
        Show={!toggle1}
        Hide={setToggle1}
        setKitMetaId={setKitMetaId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        deletedStudySiteKitMeta={deletedStudySiteKitMeta}
        getDeletedEIWRSKitMetadataData={getDeletedEIWRSKitMetadataData}
        deletedStudySiteKitMetaCount={deletedStudySiteKitMetaCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreEIWRSKitMetadata={softDeleteRestoreEIWRSKitMetadata}
        Title={"Deleted Study Kit Metadata History"}
      />
    </>
  );
};

export default StudyKitMetadataDataList;
